import { Text } from "../../../../../i18n/text.js";
import { CaptionsRadioGroupOptions, CaptionsRadioGroupRoot, CaptionsRadioGroupValue } from "../../../../../ui/captions-radio-group/component.js";
import { MenuContent } from "../../../../../ui/menu/content.js";
import { MenuItem } from "../../../../../ui/menu/item.js";
import { MenuRoot } from "../../../../../ui/menu/root.js";
import { MenuSeparator } from "../../../../../ui/menu/separator.js";
import { MenuTrigger } from "../../../../../ui/menu/trigger.js";
import ForwardRef from "../../../../../icons/dist/react/default/captions-off.js";
import { MenuChevron } from "./menu-chevron.js";
import { RadioItem } from "./radio-item.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { captionsText } from "@videojs/core/i18n/text/menu";
//#region src/internal/skins/default-video/components/menus/captions-submenu.tsx
/** @jsxImportSource react */
function CaptionsSubmenu({ ...props } = {}) {
	return /* @__PURE__ */ jsx(MenuRoot, {
		...props,
		children: /* @__PURE__ */ jsxs(CaptionsRadioGroupRoot, { children: [/* @__PURE__ */ jsxs(MenuTrigger, {
			className: "media-menu-trigger-item",
			children: [
				/* @__PURE__ */ jsx(ForwardRef, { className: "media-menu-trigger-item-icon" }),
				/* @__PURE__ */ jsx(Text, {
					token: captionsText.key,
					children: captionsText.text
				}),
				/* @__PURE__ */ jsxs("span", {
					className: "media-menu-hint",
					children: [/* @__PURE__ */ jsx(CaptionsRadioGroupValue, { className: "media-menu-hint-label" }), /* @__PURE__ */ jsx(MenuChevron, {})]
				})
			]
		}), /* @__PURE__ */ jsxs(MenuContent, {
			className: "media-menu-content",
			children: [
				/* @__PURE__ */ jsxs(MenuItem, {
					className: "media-menu-back-item",
					children: [/* @__PURE__ */ jsx(MenuChevron, { back: true }), /* @__PURE__ */ jsx(Text, {
						token: captionsText.key,
						children: captionsText.text
					})]
				}),
				/* @__PURE__ */ jsx(MenuSeparator, { className: "media-menu-separator" }),
				/* @__PURE__ */ jsx(CaptionsRadioGroupOptions, {
					className: "media-menu-radio-group",
					renderItem: (props, item) => /* @__PURE__ */ jsx(RadioItem, {
						...props,
						children: /* @__PURE__ */ jsx("span", { children: item.label })
					})
				})
			]
		})] })
	});
}
//#endregion
export { CaptionsSubmenu };

//# sourceMappingURL=captions-submenu.js.map